export default "__VITE_ASSET__DOM9EfsZ__"